// 颜色主题定义
export const COLORS = {
    // ========== Material-UI 兼容颜色（保持原有定义）==========
    primary: {
        main: '#1976d2',
        light: '#42a5f5',
        dark: '#1565c0'
    },
    tabHeader: '#1976d2', // 统一的Tab页标题颜色 (HistoryTab used primary.main)
    success: {
        main: '#2e7d32',
        light: '#66bb6a',
        dark: '#2e7d32'
    },
    info: {
        main: '#0288d1',
        light: '#29b6f6',
        dark: '#0277bd'
    },
    warning: {
        main: '#ed6c02',
        light: '#ffca28',
        dark: '#f57c00'
    },
    error: {
        main: '#d32f2f',
        light: '#ef5350',
        dark: '#c62828'
    },
    grey: {
        50: '#fafafa',
        100: '#f5f5f5',
        200: '#eeeeee',
        300: '#e0e0e0',
        400: '#bdbdbd',
        500: '#9e9e9e',
        600: '#757575',
        700: '#616161',
        800: '#424242',
        900: '#212121'
    },

    // ========== Gobel 品牌配色 ==========
    // 基于品牌指南的官方配色方案
    brand: {
        // 主品牌色 - Gobel Orange
        orange: {
            main: '#fc8c14',      // Gobel 橙色主色
            light: '#ffad42',     // 浅色变体 (悬停状态)
            dark: '#cc7000',      // 深色变体 (按压状态)
            contrastText: '#ffffff'
        },
        // 次要品牌色 - Gobel Blue  
        blue: {
            main: '#2196f3',      // 高对比度蓝色 (Material Blue 500)
            light: '#64b5f6',     // 浅色变体 (悬停状态)
            dark: '#1976d2',      // 深色变体 (按压状态)
            contrastText: '#ffffff'
        }
    },

    // ========== 数据监控相关颜色（保持原有定义）==========
    voltage: {
        high: '#4caf50',    // 绿色 - 高电压 (>3500mV)
        normal: '#ff9800',  // 橙色 - 正常电压 (3000-3500mV)
        low: '#f44336'      // 红色 - 低电压 (<3000mV)
    },

    // 温度监控颜色（合并两个temperature定义）
    temperature: {
        // 简单分类（用于显示颜色）
        hot: '#f44336',     // 红色 - 过热 (>40°C)
        warm: '#ff9800',    // 橙色 - 偏热 (30-40°C)
        normal: '#4caf50',  // 绿色 - 正常 (15-30°C)
        cold: '#2196f3',    // 蓝色 - 偏冷 (<15°C)
        // 渐变映射颜色（用于热力图等）
        normalColor: '#2e7d32',  // 正常温度颜色 (10-35°C)
        lowColor: '#115293',     // 低温度颜色 (-30°C)
        highColor: '#9a0036',    // 高温度颜色 (60°C)
        // 温度范围
        normalMin: 10,           // 正常温度最小值 (°C)
        normalMax: 35,           // 正常温度最大值 (°C)
        minTemp: -30,            // 最低温度 (°C)
        maxTemp: 60              // 最高温度 (°C)
    },

    warningLevels: {
        alarm: '#CC8F00',   // 第一级警告色 - 报警
        protection: '#EF6C00', // 第二级警告色 - 保护
        fault: '#C62828'    // 第三级警告色 - 故障
    },

    cellVoltage: {
        minColor: '#115293', // 电芯电压最低颜色 (2500mV)
        maxColor: '#9a0036', // 电芯电压最高颜色 (3650mV)
        minValue: 2500,      // 电芯电压最小值 (mV)
        maxValue: 3650       // 电芯电压最大值 (mV)
    },

    protectionGroup: {
        voltage: '#E3F2FD',    // Light Blue 50
        current: '#E8F5E9',    // Green 50
        temperature: '#FFF3E0' // Orange 50
    },

    protectionGroupDark: {
        voltage: 'rgba(25, 118, 210, 0.15)',    // Dark Blue Alpha
        current: 'rgba(46, 125, 50, 0.15)',     // Dark Green Alpha
        temperature: 'rgba(237, 108, 2, 0.15)'  // Dark Orange Alpha
    },

    systemGroup: {
        config: '#E0F2F1',     // Teal 50
        calibration: '#FCE4EC', // Pink 50
        info: '#F5F5F5'        // Grey 100
    },

    systemGroupDark: {
        config: 'rgba(0, 150, 136, 0.15)',     // Dark Teal Alpha
        calibration: 'rgba(233, 30, 99, 0.15)', // Dark Pink Alpha
        info: 'rgba(158, 158, 158, 0.15)'      // Dark Grey Alpha
    },

    historyGroup: {
        container: '#fafafa', // grey.50
        card: '#ffffff',      // white
        subBox: '#fafafa'     // grey.50
    },

    historyGroupDark: {
        container: 'rgba(255, 255, 255, 0.05)', // Dark container
        card: 'rgba(255, 255, 255, 0.1)',       // Dark card
        subBox: 'rgba(255, 255, 255, 0.05)'     // Dark subBox
    },

    // ========== 扩展的数据可视化颜色（新增）==========
    dataViz: {
        battery: {
            full: '#4caf50',      // 满电 (>90%)
            good: '#8bc34a',      // 良好 (60-90%)
            medium: '#ff9800',    // 中等 (30-60%)
            low: '#ff5722',       // 低电 (10-30%)
            critical: '#f44336'   // 极低 (<10%)
        },
        power: {
            high: '#f44336',      // 高功率
            medium: '#ff9800',    // 中功率
            low: '#4caf50',       // 低功率
            idle: '#9e9e9e'       // 空闲
        },
        signal: {
            excellent: '#4caf50',  // 信号极好
            good: '#8bc34a',       // 信号良好
            fair: '#ff9800',       // 信号一般
            poor: '#ff5722',       // 信号较差
            none: '#f44336'        // 无信号
        }
    },

    // ========== 图表配色方案（新增）==========
    charts: {
        // 数据系列颜色（按优先级排列，使用品牌色为主）
        series: [
            '#fc8c14',  // Gobel 橙色 (系列1)
            '#006699',  // Gobel 蓝色 (系列2)
            '#4caf50',  // 绿色 (系列3)
            '#ff9800',  // 橙色 (系列4)
            '#2196f3',  // 蓝色 (系列5)
            '#9c27b0'   // 紫色 (系列6)
        ],
        // 图表元素
        grid: '#e0e0e0',        // 网格线
        axes: '#666666',        // 坐标轴
        text: '#333333',        // 文本标签
        background: '#ffffff',  // 背景
        tooltip: {
            background: '#ffffff',
            border: '#e0e0e0'
        }
    },

    // ========== 设备状态颜色（新增）==========
    deviceStatus: {
        online: '#4caf50',      // 在线
        offline: '#f44336',     // 离线
        connecting: '#ff9800',  // 连接中
        error: '#f44336',       // 错误
        maintenance: '#9e9e9e'  // 维护中
    },

    // ========== 中性色板（新增，补充 grey 定义）==========
    neutral: {
        text: {
            primary: '#333333',
            secondary: '#666666',
            hint: '#999999',
            disabled: '#bdbdbd'
        },
        background: {
            white: '#ffffff',
            light: '#f8f9fa',
            gray: '#f5f5f5'
        },
        border: {
            light: '#e0e0e0',
            medium: '#bdbdbd',
            dark: '#757575'
        }
    },

    // ========== 暗色主题配色 ==========
    dark: {
        background: {
            default: '#121212',
            paper: '#1e1e1e',
            elevated: '#2a2a2a',
            navbar: '#202124'  // Navbar背景色（暗色主题）
        },
        text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)'
        },
        border: {
            light: 'rgba(255, 255, 255, 0.12)',
            medium: 'rgba(255, 255, 255, 0.2)',
            dark: 'rgba(255, 255, 255, 0.3)'
        }
    },

    // ========== 主题感知颜色（根据明暗主题变化）==========
    themed: {
        // 数据值颜色（InfoRow等组件使用）
        dataValue: {
            light: '#006699',    // 亮色主题：品牌蓝
            dark: '#64b5f6'      // 暗色主题：亮蓝色，更好的对比度
        },
        // Chip/Badge文字颜色（在彩色背景上）
        chipText: {
            light: '#ffffff',    // 亮色主题：白色
            dark: '#1a1a1a'      // 暗色主题：深色，更好的对比度
        }
    }
};

// 便捷的颜色访问函数
export const getColor = (type, shade = 'main') => {
    if (COLORS[type] && COLORS[type][shade]) {
        return COLORS[type][shade];
    }
    return COLORS[type] || type;
};